
import React from 'react';
import { Skeleton } from '@/components/ui/skeleton';

export const AnalysisListSkeleton = () => {
  return (
    <div className="space-y-3 py-6 px-2">
      {Array.from({ length: 6 }).map((_, index) => (
        <div
          key={index}
          className="p-4 rounded-lg border border-border bg-card"
        >
          <div className="flex items-start justify-between">
            <div className="flex-1 min-w-0 space-y-2">
              <Skeleton className="h-4 w-3/4" />
              <Skeleton className="h-3 w-1/2" />
            </div>
            <Skeleton className="h-8 w-8 rounded-full" />
          </div>
        </div>
      ))}
    </div>
  );
};
